import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';
import { Container, Message } from './WidgetEmptyState.styled';

const WidgetEmptyState = ({ message }) => {
  return (
    <Container>
      <Message>{message}</Message>
    </Container>
  );
};

WidgetEmptyState.propTypes = {
  message: PropTypes.string,
};

WidgetEmptyState.defaultProps = {
  message: WIDGET_GRID_COPY.states.noData,
};

export default WidgetEmptyState;
